import { useEffect } from "react";
import { useLocation } from "react-router";
import { setFrontChatVisible } from "@/shared/lib/frontChat";

/**
 * Route-aware mount for the Front support chat. The launcher shows on all
 * owner-facing surfaces (marketing, auth, `/app/*`) and is hidden on the public
 * `/share/:token` collect pages that address-request recipients see.
 *
 * Renders nothing — Front owns its own launcher UI (`useDefaultLauncher`). Mount
 * once inside the router tree so `useLocation` reflects client navigations.
 */
export function FrontChatController() {
  const { pathname } = useLocation();
  const visible = !pathname.startsWith("/share/");

  useEffect(() => {
    setFrontChatVisible(visible);
  }, [visible]);

  return null;
}
